/*
 * "Add these before you go" as a self-advancing carousel.
 *
 * The bag is where attention is thinnest, so a still row gets scrolled past. This moves it on
 * every few seconds, which is enough to get it looked at without hijacking the page.
 *
 * Rules it plays by:
 *  - stops the moment someone touches it, and never starts again. Something that keeps sliding
 *    while you are trying to tap a size is worse than no carousel at all;
 *  - stops while the drawer is closed or the tab is in the background;
 *  - does nothing at all for anyone who has asked for reduced motion.
 *
 * The cart drawer re-renders its whole contents on every add, so this binds by walking the DOM
 * on demand rather than holding references.
 */
(function () {
	var INTERVAL = 2600;

	function setup(root) {
		var track = root.querySelector('[data-ml-upsell-track]');
		var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ml-upsell-dot]'));
		if (!track || track.dataset.mlBound) return;
		track.dataset.mlBound = '1';

		var items = Array.prototype.slice.call(track.children);
		if (items.length < 2) return;

		var index = 0;
		var timer = null;
		var stopped = false;

		function paint() {
			dots.forEach(function (dot, i) {
				dot.classList.toggle('is-on', i === index);
			});
		}

		function go(next, smooth) {
			index = (next + items.length) % items.length;
			track.scrollTo({
				left: items[index].offsetLeft - track.offsetLeft,
				behavior: smooth === false ? 'auto' : 'smooth',
			});
			paint();
		}

		function stop() {
			stopped = true;
			if (timer) clearInterval(timer);
			timer = null;
		}

		function start() {
			if (stopped || timer) return;
			timer = setInterval(function () {
				if (document.hidden || !root.isConnected || !root.offsetParent) return;
				go(index + 1);
			}, INTERVAL);
		}

		/* Any deliberate interaction hands control over for good. */
		['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
			track.addEventListener(evt, stop, { passive: true });
		});

		dots.forEach(function (dot, i) {
			dot.addEventListener('click', function () {
				stop();
				go(i);
			});
		});

		/* Keep the dots honest when someone swipes the track themselves. */
		var scrollTick;
		track.addEventListener(
			'scroll',
			function () {
				clearTimeout(scrollTick);
				scrollTick = setTimeout(function () {
					var nearest = 0;
					var best = Infinity;
					items.forEach(function (item, i) {
						var d = Math.abs(item.offsetLeft - track.offsetLeft - track.scrollLeft);
						if (d < best) {
							best = d;
							nearest = i;
						}
					});
					index = nearest;
					paint();
				}, 90);
			},
			{ passive: true }
		);

		if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
	}

	function scan() {
		document.querySelectorAll('[data-ml-upsell]').forEach(setup);
	}

	if (document.readyState !== 'loading') scan();
	else document.addEventListener('DOMContentLoaded', scan);

	/* The drawer replaces its markup on every add, so re-scan when it changes. */
	var observer = new MutationObserver(function () {
		scan();
	});
	observer.observe(document.documentElement, { childList: true, subtree: true });
})();
